/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */

import "./FooterTop.scss";

import * as FooterTopStyles from "./FooterTopInbuiltStyle";

import { Fabric, IStackTokens, Icon, Stack } from "@fluentui/react";
import { FooterItems, OpenInNewTab, ChevronRightMed } from "../constants";
import React from "react";

import { getFooterLinks } from "../staticLinks";


const sectionStackTokens: IStackTokens = { childrenGap: 5 };
const firstStackTokens: IStackTokens = { childrenGap: "10 30" };

const BrandingFooter: React.FunctionComponent = () => {
  const _hrefs = getFooterLinks();

  return (
    <Stack
      horizontal
      wrap
      styles={FooterTopStyles.containerStackStyles}
      tokens={sectionStackTokens}
    >
      <Stack
        horizontal
        wrap
        styles={FooterTopStyles.firstStackStyles}
        tokens={firstStackTokens}
        role="contentinfo"
        aria-label={`${FooterItems.Additional_support}`}
      >
        <a style={FooterTopStyles.firstStackItemStyles} href={_hrefs.FAQ}>
          <Icon
            iconName="OfficeChat"
            styles={FooterTopStyles.iconStylesForStacksParent}
          />
          <span>
            {`${FooterItems.FAQ}`}
            <Icon
              iconName={ChevronRightMed}
              styles={FooterTopStyles.iconStylesForStacks}
            />
          </span>
        </a>
        <a
          style={FooterTopStyles.firstStackItemStyles}
          href={_hrefs.InterviewTips}
        >
          <Icon
            iconName="PageShared"
            styles={FooterTopStyles.iconStylesForStacksParent}
          />
          <span>
            {`${FooterItems.Interview_tips}`}
            <Icon
              iconName={ChevronRightMed}
              styles={FooterTopStyles.iconStylesForStacks}
            />
          </span>
        </a>
        <a
          style={FooterTopStyles.firstStackItemStyles}
          href={_hrefs.AccessibilityRequest}
          target={OpenInNewTab}
        >
          <Icon
            iconName="HeadSet"
            styles={FooterTopStyles.iconStylesForStacksParent}
          />
          <span>
            {`${FooterItems.Accessibility_request}`}
            <Icon
              iconName={ChevronRightMed}
              styles={FooterTopStyles.iconStylesForStacks}
            />
          </span>
        </a>
        <a
          style={FooterTopStyles.firstStackItemStyles}
          href={_hrefs.Comment}
          target={OpenInNewTab}
        >
          <Icon
            iconName="Comment"
            styles={FooterTopStyles.iconStylesForStacksParent}
          />
          <span>
            {`${FooterItems.Support}`}
            <Icon
              iconName={ChevronRightMed}
              styles={FooterTopStyles.iconStylesForStacks}
            />
          </span>
        </a>
        <a
          style={FooterTopStyles.firstStackItemStyles}
          href={_hrefs.LegalPolicies}
        >
          <Icon
            iconName="Compare"
            styles={FooterTopStyles.iconStylesForStacksParent}
          />
          <span>
            {`${FooterItems.Legal_policies}`}
            <Icon
              iconName={ChevronRightMed}
              styles={FooterTopStyles.iconStylesForStacks}
            />
          </span>
        </a>
        <a
          style={FooterTopStyles.firstStackItemStyles}
          href={_hrefs.DPN}
          target={OpenInNewTab}
        >
          <Icon
            iconName="LaptopSecure"
            styles={FooterTopStyles.iconStylesForStacksParent}
          />
          <span>
            {
              `${FooterItems["Microsoft_Data_Privacy_Notice_(DPN)"]}`
            }
            <Icon
              iconName={ChevronRightMed}
              styles={FooterTopStyles.iconStylesForStacks}
            />
          </span>
        </a>
      </Stack>

      <Stack
        horizontal
        styles={FooterTopStyles.stackStyles}
        role="contentinfo"
        aria-label={
          `${FooterItems.Follow_us_on_social_media}`
        }
      >
        <div className="ac-ms-bottom-footer-container">
          <span
            style={FooterTopStyles.itemStyleLeft}
            className="ac-ms-bottom-footer-left"
          >
            <h2>
              {
                `${FooterItems.Follow_Microsoft_Careers}`
              }
            </h2>
            <span>
              <a
                href={_hrefs.LinkedInMSAccount}
                style={FooterTopStyles.marginLinkedIn}
                target={OpenInNewTab}
              >
                <img src={_hrefs.LinkedInLogo} alt="LinkedIn" />
              </a>
              <a
                href={_hrefs.TwitterMSAccount}
                style={FooterTopStyles.marginImgs}
                target={OpenInNewTab}
              >
                <img src={_hrefs.TwitterLogo} alt="Twitter" />
              </a>
              <a
                href={_hrefs.FacebookMSAccount}
                style={FooterTopStyles.marginImgs}
                target={OpenInNewTab}
              >
                <img src={_hrefs.FacebookLogo} alt="Facebook" />
              </a>
              <a
                href={_hrefs.InstaMSAccount}
                style={FooterTopStyles.marginImgs}
                target={OpenInNewTab}
              >
                <img src={_hrefs.InstaLogo} alt="Instagram" />
              </a>
            </span>
          </span>
        </div>
      </Stack>
    </Stack>
  );
};

// eslint-disable-next-line
const BrandingFooterWrapper = () => (
  <Fabric>
    <BrandingFooter/>
  </Fabric>
);
export default BrandingFooterWrapper;
